module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAkUlEQVQ4T93TMQ4BURSF4f9fmYhGNKK1IhtQikI3q1DqlCprOSIZgpDMTK5m3gK+nHfuvVL8LPYYGZjkAOzU46+qen05yQRogKV6+ob2Au9AkjmwBxbq+RPtDbboCtgCM/Xyig4CW3QNbICpen2gb2CSDNlL9en8N2HXdEnqOiydcvkell9Kl44HT7nklseR8AZwBTYV5qDL4wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/index_btn_more.png
// module id = bAib
// module chunks = 1